export default "__VITE_ASSET__54f97b2c__"